module.exports = __webpack_public_path__ + "img/logoDoc.9b830891.svg";